/**
 * Copyright IBM Corp. 2022, 2026
 */

import classNames from 'classnames'
import * as MenuPrimitive from '../menu-primitive'
import { Item } from './item'
import { TruncationButton } from './truncation-button'
import type { BreadcrumbProps, BreadcrumbTruncationProps } from './types'
import s from './style.module.scss'

const Root = ({
	itemsCanWrap = true,
	ariaLabel = 'breadcrumbs',
	children,
	className,
	...rest
}: BreadcrumbProps) => {
	return (
		<nav
			className={classNames(
				s.breadcrumbs,
				{
					[s['items-can-wrap']]: itemsCanWrap,
				},
				className,
			)}
			aria-label={ariaLabel}
			{...rest}
		>
			<ol className={s.list}>{children}</ol>
		</nav>
	)
}

const Truncation = ({
	ariaLabel,
	children,
	...rest
}: BreadcrumbTruncationProps) => {
	return (
		<li className={classNames(s.item, s.truncation)} {...rest}>
			<MenuPrimitive.Provider>
				<MenuPrimitive.Toggle>
					<TruncationButton />
				</MenuPrimitive.Toggle>
				<MenuPrimitive.Content>
					<div className={s['truncation-content']}>
						<ol className={s.sublist}>{children}</ol>
					</div>
				</MenuPrimitive.Content>
			</MenuPrimitive.Provider>
		</li>
	)
}

const Breadcrumbs = { Root, Item, Truncation }

export { Breadcrumbs }
